var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._l((_vm.segments),function(segment,index){return [(segment.match)?_c('span',{key:'match-' + index,staticClass:"audit-search-highlight"},[_vm._v(" "+_vm._s(segment.text)+" ")]):_c('span',{key:'text-' + index},[_vm._v(_vm._s(segment.text))])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }